// extracted by mini-css-extract-plugin
module.exports = {"form":"content_form__WCd0t","inputDescription":"content_inputDescription__3Bu8Q"};